export function moneyFormat(x: string): string {
  // Конвертируем в число и форматируем с 2 знаками после запятой
  const number = parseFloat(x)
  const formatted = number.toFixed(2)

  // Заменяем точку на запятую
  let result = formatted.replace('.', ',')

  // Используем регулярное выражение для добавления пробелов
  result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  return result
}
